import moment from 'moment';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from "primereact/inputtextarea";
import { Knob } from 'primereact/knob';
import { Messages } from 'primereact/messages';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useCallback, useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import count_days from '../../functions/count_days';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';
import { _endPoints, baseUrl, getpaymenttype, sethandelbooking } from '../../Helper/links';
import pattern from '../../Helper/pattern';
import API from '../../Helper/server/API';
import { useWhatsapp } from '../../whatsapp/WhatsappContext';
import { InvoiceContext } from '../../bookings/invoice/Invoice_Context';
import InvoiceCustomer from '../../bookings/invoice/invoice_customer';
import PaidInvoice from '../../bookings/payments/pay_reservation';
import { Avatar } from 'primereact/avatar';
import ServiceReceiptMini from '../invoice/ServiceReceiptMini';
import img_table_beach from "../../public/images/waterpark_2.png";
import { View_rule_type, View_service_img } from '../../constants/dataView';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { addLocale } from 'primereact/api';

function BookingServiceConfirmStep({
    bookingServiceData,
    setbookingServiceData,
    bookingCustomerData,
    setbookingCustomerData,
    payment_types,
    paymentmethod,
    set_paymentmethod
}) {
    const toast = useRef(null);
    const msgs = useRef(null);
    const opUpdateRefs = useRef({});
    const { SendWhatsAppMsg } = useWhatsapp();
    const [reservations, set_reservations] = useState([])
    const [ViewPaid, setViewPaid] = useState(false);
    const [dataPaid, setDataPaid] = useState(null);
    const [InvoicePaid, setInvoicePaid] = useState(false);
    const [loding, set_loding] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [apartmentData, set_apartmentData] = useState([]);
    const [customerData, setcustomerData] = useState(bookingCustomerData);

    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });

    var monthView = 0;
    const [loading_handel, set_loading_handel] = useState(true);
    const items = Array.from({ length: 5 }, (v, i) => i);
    const HandelServiceBooking = async (date_check_in = null) => {
        set_loading_handel(true)
        const response = await API.post(_endPoints.reservations.services.handel + '?ID_service=' + bookingServiceData?.ID_service + '&date_check_in=' + moment(date_check_in).format('YYYY-MM-DD'))
        if (response && response?.success && response?.success === 1) {
            setbookingServiceData(response.data)
        }
        else {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }

        set_loading_handel(false)

    }
    const view_paymentmethod = (e) => {
        if (paymentmethod?.name_payment_type) {
            return <span style={{ fontFamily: "Cairo" }}>{paymentmethod?.name_payment_type}</span>
        }
        else {
            return <span style={{ fontFamily: "Cairo" }}>-</span>
        }
    }
    const handel_paymentmethod = (e) => {
        if (pattern.number_int.test(e.value?.id_payment_type)) {
            set_paymentmethod(e.value)
            document.getElementById("lpayment_type").style.color = "black";
            if (e.value?.id_payment_type === 2) {
                if (msgs && msgs.current) {
                    msgs.current.clear();
                    msgs?.current?.show([
                        {
                            sticky: true, severity: 'warn', summary: 'تــحذيــر', detail: 'لايمــكن إلغــاء الحجــز عنــد دفــع عن طريــق  الدفــع الإلكتــروني', closable: false,
                            style: {
                                fontFamily: "Cairo",
                                fontSize: "1rem",
                                padding: "1rem"
                            },
                        },
                    ]);
                }
            }
            else {
                if (msgs && msgs.current) {
                    msgs.current.clear();
                }
            }
        }
        else {
            document.getElementById("lpayment_type").style.color = "red";
        }
    }




    const SetBooking = async (e) => {
        set_loding(true)
        // if (!(paymentmethod && paymentmethod?.id_payment_type && pattern.number_int.test(paymentmethod?.id_payment_type))) {
        //     document.getElementById("lpayment_type").style.color = 'red';
        //     msg = 'أرجــو إختيــار طريقــة الدفـع'
        //     test_validtion = false;
        // }
        if (customerData?.ID_customer != null && pattern.number_int.test(customerData?.ID_customer) === false) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: 'أرجــو أختيــار العميــل'
            });
        }
        else if (bookingServiceData?.length > 0) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: 'أرجــو  أختيــار الخدمـة'
            });
        }
        else {
            var data = {
                id_customer: customerData?.ID_customer ? customerData.ID_customer : null,
                payment_type: paymentmethod,
                booking: bookingServiceData
            }
            const response = await API.post(_endPoints.reservations.services.booking, data)
            if (response?.success === 1) {
                set_apartmentData([])
                set_reservations(response?.data)
                setViewPaid(true)
                HandelServiceBooking(bookingServiceData?.date_check_in)
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'success', summary: 'نجــاح', detail: response?.msg
                });
                if (response?.errors) {
                    toast.current.show({
                        style: {
                            fontFamily: "Cairo",
                            fontSize: "1.2rem"
                        },
                        life: 5000,
                        severity: 'error', summary: 'خطــاء', detail: ''
                    });
                }
            }
            else if (response?.success === 0) {
                if (response?.service_space) {
                    setbookingServiceData({ ...bookingServiceData, capacity_available: response?.service_space?.capacity_available })
                }
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
                if (response?.errors) {
                    if (response?.booking)
                        set_apartmentData(response.booking)
                }
            }
        }
        set_loding(false)
    }
    useEffect(() => {
        HandelServiceBooking(moment(new Date()).format('YYYY-MM-DD'));
        // if (!customerData?.ID_customer) {
        //     msgs.current.show([
        //         {
        //             severity: 'error', detail: '', summary: "يرجى اختيار العميل لإتمام عملية الحجز.", sticky: true, closable: false, style: {
        //                 padding: "1rem"
        //             }
        //         }
        //     ]);
        // }
        // else if (customerData?.state === 0) {
        //     msgs.current.show([
        //         {
        //             severity: 'error', detail: '', summary: "العميــل فــي قائمــة الحظــر.", sticky: true, closable: false, style: {
        //                 padding: "1rem"
        //             }
        //         }
        //     ]);
        // }



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [value, setValue] = useState(0);
    const view_test = (value) => {

    }

    const getTotalPrice = (bookingServiceData) => {
        var total_price = 0
        bookingServiceData?.pricing_rules?.forEach(item => {
            if (item?.total_price) {
                total_price += item?.total_price;
            }
        })
        return total_price
    }

    return (
        <div>
            <style>{`  .service-badge {
                    background: #dcfce7;
                    color: #166534;
                    padding: 4px 10px;
                    border-radius: 12px;
                    font-size: 0.8rem;
                    font-weight: 800;
                    margin-bottom: 15px;
                    align-self: center;
                    box-shadow: 0 4px 10px rgba(22, 101, 52, 0.1);
                }
                .service-badge-red {
                    background: #fee2e2;
                    color: #b91c1c;
                    padding: 4px 10px;
                    border-radius: 12px;
                    font-size: 0.8rem;
                    font-weight: 800;
                    margin-bottom: 15px;
                    align-self: center;
                    box-shadow: 0 4px 10px rgba(22, 101, 52, 0.1);

                `}</style>
            <div class="ibox">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="ibox invoice-print" >
                    {/* <div className="invoice-header">
                        <div>
                            <div className="col-md-12">
                                <div className="row font-15">
                                    <div className="col-md-12 " style={{ border: "1px solid rgba(0,0,0,.1" }}>
                                        <div className="m-b-5 font-bold mt-4 " >بيـــانات العميـــل</div>
                                        <hr></hr>

                                        <div className="m-b-5 font-bold" >
                                            <i class="ti-user font-26 text-muted ml-2" dir='rtl'></i> {customerData?.visitor_name ? customerData?.visitor_name : <>-</>}
                                        </div>
                                        <div className="m-b-5 font-bold pt-1" >
                                            <i class="fa fa-phone font-26 text-muted ml-3 "></i>
                                            {customerData?.phone_number ?
                                                <>{customerData?.phone_number} <small class=" text-muted" dir='ltr' > +218 </small></>
                                                : <>-</>}
                                        </div>
                                        <div className="m-b-5 font-bold pt-1" >
                                            <i class="fa fa-whatsapp font-26 text-muted ml-3 "></i>
                                            {customerData?.whatsapp_number ?
                                                <>{customerData.whatsapp_number} +</>
                                                : <>-</>}
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div class="row">
                        <div class="col-md-12">
                            <div className="row font-15">
                                {
                                    loading_handel ?
                                        <div className="col-md-12 " >
                                            <div className='row '>
                                                <div className='col-md-2 pt-5'>
                                                    <center>
                                                        <Skeleton shape="circle" size="150px" />
                                                    </center>
                                                </div>
                                                <div className="col-md-10 pt-5 mt-5">
                                                    <center>
                                                        <Skeleton width="100%" height="100px" />
                                                    </center>
                                                </div>
                                            </div>
                                            <hr></hr>
                                            <div className='row'>
                                                <div className="col-md-12">
                                                    <center>
                                                        <Skeleton width="100%" height="150px" />
                                                    </center>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="col-md-12 " >
                                            <div className="font-bold mt-4 " ></div>
                                            <div className='row'>
                                                {loading_handel ? <div className="col-md-10">
                                                    <center>
                                                        <Skeleton shape="circle" size="150px" />
                                                    </center>
                                                </div> : <></>}
                                                <div className='col-md-2 pt-5'>
                                                    <div class="media-img">
                                                        <center>
                                                            <Avatar image={View_service_img(bookingServiceData)} className="flex mr-2" size="xlarge" style={{ width: "150px", height: "150px", transition: "transform 10s ease" }} shape="circle" />
                                                        </center>
                                                    </div>
                                                </div>



                                                <div className='col-md-10'>
                                                    <hr></hr>
                                                    <br></br>
                                                    <div className='row'>
                                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                                            <div class="media-heading font-16" >

                                                                {bookingServiceData?.service_name_ar}

                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                                            {/* <div class="media-heading font-16" >

                                                                السعة القصوى : <span > {bookingServiceData?.capacity}

                                                                    {bookingServiceData?.capacity_type == 'reservation' ? " حجز " : " شخص "}
                                                                </span>
                                                            </div> */}

                                                            <div class="media-heading font-16 mt-2" >

                                                                السعة المتاحة :

                                                                <span className={bookingServiceData?.capacity_available <= 1 ? "service-badge-red mr-2" : "service-badge mr-2"} style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                                                                    {
                                                                        bookingServiceData?.capacity_available

                                                                    }
                                                                    {bookingServiceData?.capacity_type == 'reservation' ? " حجز " : " شخص "}
                                                                </span>

                                                            </div>

                                                        </div>


                                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                                            <div class="media-heading font-16" >

                                                                السعر  : <span > {bookingServiceData?.price}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <hr></hr>
                                                    <br></br>
                                                    <div className='row'>
                                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                                            <div class="media-heading font-16" >
                                                                <i class="ti-user font-26 text-muted m-3" dir='rtl'></i>
                                                                عدد الاشخاص
                                                                :
                                                                {bookingServiceData?.persons}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                                            <div class="media-heading font-16" >
                                                                <i class="ti-user font-26 text-muted m-3" dir='rtl'></i>
                                                                الحد الادني للأشخاص
                                                                :
                                                                {bookingServiceData?.min_persons}
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                                            <div class="media-heading font-16" >
                                                                <i class="ti-user font-26 text-muted m-3" dir='rtl'></i>
                                                                الحد الاقصي للأشخاص
                                                                :
                                                                {bookingServiceData?.max_persons}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className='col-md-12 col-12 mt-4'>
                                                    <div class="table-responsive">
                                                        <table className="table table-bordered table-striped no-margin table-invoice" style={{ width: "100%" }}>
                                                            <thead className="color-view bg-ebony" style={{ fontSize: "15px" }}>
                                                                <tr >
                                                                    <th colSpan={1} className="text-center" style={{ fontSize: "1.2rem", color: "white" }}>
                                                                        تــاريخ الدخــول
                                                                    </th>
                                                                    <th colSpan={1} className="text-center" style={{ fontSize: "1.2rem" }}>
                                                                        <Calendar value={moment(bookingServiceData?.date_check_in).toDate()} onChange={(e) => {
                                                                            setbookingServiceData({ ...bookingServiceData, date_check_in: moment(e.value).format("YYYY-MM-DD") })
                                                                            HandelServiceBooking(moment(e.value).format("YYYY-MM-DD"))
                                                                        }} showButtonBar locale="ar"
                                                                            dateFormat='yy-mm-dd' panelStyle={{ width: "30rem" }} className='w-50' inputStyle={{ fontSize: "1.2rem", fontWeight: "bold", textAlign: "center" }} minDate={new Date()}
                                                                        ></Calendar>
                                                                    </th>
                                                                    <th colSpan={3} className="text-center" style={{ fontSize: "1.2rem" }}>

                                                                    </th>
                                                                </tr>
                                                                {
                                                                    bookingServiceData?.pricing_rules?.length > 0 ?

                                                                        <tr style={{ color: "white", fontSize: "1.2rem" }}>
                                                                            <th style={{ width: "10%", textAlign: "center" }}>الخدمة</th>
                                                                            <th style={{ width: "10%", textAlign: "center" }}>العمـر</th>
                                                                            <th style={{ width: "10%", textAlign: "center" }}>عدد الأشخــاص</th>
                                                                            <th style={{ width: "10%", textAlign: "center" }}>سعـر الوحــدة</th>

                                                                            <th style={{ width: "10%", textAlign: "center" }}>الإجمــالي</th>

                                                                        </tr>
                                                                        : null
                                                                }
                                                            </thead>
                                                            <tbody>
                                                                {bookingServiceData?.pricing_rules?.map((item, index) => (
                                                                    <tr key={index} style={{ fontSize: "1.2rem", fontWeight: "bold" }} >
                                                                        <td style={{ textAlign: "center" }}>{View_rule_type(item)}</td>
                                                                        <td style={{ textAlign: "center" }}>من {item?.min_age} سنة الي {item?.max_age} سنة</td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <div className='row'>
                                                                                <div className='col-md-4 col-4'>
                                                                                    <Button icon="pi pi-plus" className="p-button-outlined p-button-rounded p-button-success" style={{ width: "4rem", height: "4rem" }} onClick={() => {
                                                                                        if (bookingServiceData?.selected_persons * 1 < bookingServiceData?.max_persons * 1
                                                                                            && item.persons * 1 < item.max_persons * 1
                                                                                        ) {
                                                                                            item.persons = item.persons * 1 + 1;
                                                                                            let extra_persons = Math.max(0, item.persons * 1 - item.min_persons * 1);
                                                                                            item.total_price = extra_persons * item.price * 1;

                                                                                            let new_total_price = bookingServiceData.price * 1;
                                                                                            bookingServiceData.pricing_rules.forEach(rule => {
                                                                                                let rule_extra = Math.max(0, rule.persons * 1 - rule.min_persons * 1);
                                                                                                new_total_price += rule_extra * rule.price * 1;
                                                                                                rule.total_price = rule_extra * rule.price * 1;
                                                                                            });

                                                                                            setbookingServiceData({
                                                                                                ...bookingServiceData,
                                                                                                total_price: new_total_price,
                                                                                                selected_persons: bookingServiceData?.selected_persons * 1 + 1,
                                                                                                pricing_rules: bookingServiceData?.pricing_rules
                                                                                            })
                                                                                        }
                                                                                    }}></Button>
                                                                                </div>
                                                                                <div className='col-md-4 col-4 ' >
                                                                                    <h4 className="font-bold mt-4">{item?.persons}
                                                                                        <i className="pi pi-user mr-2 "></i>
                                                                                    </h4>
                                                                                </div>
                                                                                <div className='col-md-4 col-4'>
                                                                                    <Button icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger " style={{ width: "4rem", height: "4rem" }} onClick={() => {
                                                                                        if (item.persons * 1 > item.min_persons * 1) {
                                                                                            item.persons = item.persons * 1 - 1;
                                                                                            let extra_persons = Math.max(0, item.persons * 1 - item.min_persons * 1);
                                                                                            item.total_price = extra_persons * item.price * 1;

                                                                                            let new_total_price = bookingServiceData.price * 1;
                                                                                            bookingServiceData.pricing_rules.forEach(rule => {
                                                                                                let rule_extra = Math.max(0, rule.persons * 1 - rule.min_persons * 1);
                                                                                                new_total_price += rule_extra * rule.price * 1;
                                                                                                rule.total_price = rule_extra * rule.price * 1;
                                                                                            });

                                                                                            setbookingServiceData({
                                                                                                ...bookingServiceData,
                                                                                                total_price: new_total_price,
                                                                                                selected_persons: bookingServiceData?.selected_persons * 1 - 1,
                                                                                                pricing_rules: bookingServiceData?.pricing_rules
                                                                                            })
                                                                                        }
                                                                                    }}></Button>
                                                                                </div>
                                                                            </div>

                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>{item?.price} د.ل</td>
                                                                        <td style={{ textAlign: "center" }}>{item?.total_price} د.ل</td>
                                                                    </tr>
                                                                ))}
                                                                <tr className="color-view bg-ebony font-bold" style={{ fontSize: "1.2rem" }}>
                                                                    <td colSpan={2} style={{ textAlign: "center", color: "white" }}>إجمــالى عدد الأشخــاص</td>
                                                                    <td style={{ textAlign: "center", color: "white" }}>{bookingServiceData?.selected_persons}</td>
                                                                    <td style={{ textAlign: "center", color: "white" }}>
                                                                        إجمــالى السعــر

                                                                    </td>

                                                                    <td style={{ textAlign: "center", color: "white" }}>

                                                                        {bookingServiceData?.total_price ?? 0} د.ل
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-12 mt-2'>
                                                    <center>
                                                        <label htmlFor="ingredient1" id='lpayment_type'>طريقة الدفع</label>
                                                        <br />
                                                        <Dropdown value={paymentmethod} onChange={(e) => handel_paymentmethod(e)} options={payment_types} optionLabel="name_payment_type" dir='rtl'
                                                            placeholder="أختــار طريقــة الدفــع" className="col-4 col-md-4" style={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo" }}
                                                            valueTemplate={view_paymentmethod} emptyMessage={<center>لا توجد خيارات متاحة</center>}
                                                        />
                                                    </center>
                                                </div>


                                                <div className='col-md-12 p-5'>
                                                    <center>
                                                        <Button label="حجـــــز" raised severity='success' style={{ fontFamily: "Cairo", width: "35vh" }} disabled={loading_handel || customerData?.state === 0 || bookingServiceData?.length === 0 ? true : false}
                                                            onClick={SetBooking} loading={loding}
                                                        />
                                                    </center>
                                                </div>

                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            {
                ViewPaid && reservations ?
                    (
                        <>
                            <Dialog dir="rtl" header="إيصال الخدمة"
                                maximizable style={{ width: '100mm', fontFamily: "Cairo", minHeight: "100vh" }}
                                visible={ViewPaid} onHide={() => setViewPaid(false)} maximized={window.innerWidth <= 1230 ? true : false}
                            >
                                <ServiceReceiptMini
                                    bookingData={bookingServiceData}
                                    customerData={customerData}
                                    reservationData={reservations}
                                    props={{ hideDialog: () => setViewPaid(false) }}
                                />
                            </Dialog>
                        </>
                    )
                    :
                    (null)
            }
            {
                InvoicePaid ?
                    (
                        <>
                            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={true} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setInvoicePaid(false)} maximized={window.innerWidth <= 1230 ? true : false} >
                                <InvoiceContext.Provider value={dataPaid} >
                                    {dataPaid && <InvoiceCustomer></InvoiceCustomer>}
                                </InvoiceContext.Provider>
                            </Dialog>
                        </>
                    )
                    :
                    (null)
            }
        </div >
    )
}

export default BookingServiceConfirmStep